import { render, staticRenderFns } from "./PhantomForm.vue?vue&type=template&id=84967220&scoped=true&"
import script from "./PhantomForm.vue?vue&type=script&lang=js&"
export * from "./PhantomForm.vue?vue&type=script&lang=js&"
import style0 from "./PhantomForm.vue?vue&type=style&index=0&id=84967220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84967220",
  null
  
)

export default component.exports
import {QScrollArea,QInput,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QInput,QSelect})
